import React from 'react'

const RedDot = () => {
  return (
    <div
      style={{width: '8px', height: '8px', backgroundColor: '#FF5448'}}
      className="rounded-full"
    />
  )
}

export { RedDot }